import { useEffect, useState, useRef } from 'react';
import styles from './FJClothesChangerLeft.module.less';
import FJLocalStore from '../../../store/FJLocalStore';
import PropTypes from 'prop-types';
import FJGenerateButton from '../../../common/components/FJGenerateButton/FJGenerateButton';
import FJImageUpload from '../FJImageUpload/FJImageUpload';
import PeopleIcon from '../../../assets/svg/people.svg?react';
import ClothesIcon from '../../../assets/svg/clothes.svg?react';
import ClothesSmallIcon from '../../../assets/svg/clothes-small.svg?react';
import PeopleSmallIcon from '../../../assets/svg/people-small.svg?react';
import ExclamationIcon from '../../../assets/svg/exclamation-point.svg?react';
import { CLOTHES_CHANGER_STYLE_LIST } from '../../../config/dataConfig/FJClothesChangerData';
import FJClothesChangerStyleList from '../FJClothesChangerStyleList/FJClothesChangerStyleList';
import classNames from 'classnames';
import FJAppLeft from '../../FJMainPreview/FJAppLeft/FJAppLeft';
import FJTipsContent from './FJTipsContent.jsx';
import FJClothesChangerConfig from '../../../config/appConfig/FJClothesChangerConfig.js';

const FJClothesChangerLeft = props => {
    const {
        onGenerate,
        taskStatus,
        freeNumCreation,
        creditNumber,
        peopleImageInfo,
        clothesImageInfo,
        onUploadImage,
        openMediaLibrary,
        isProjectLoading,
        onSelectClothes,
        selectedName,
    } = props;
    const isFree = freeNumCreation > 0 && creditNumber < FJClothesChangerConfig.unitPrice;
    const tipsPanel = useRef();
    const [isShowTips, setIsShowTips] = useState(false);

    const _onClickTips = () => {
        setIsShowTips(true);
    };

    useEffect(() => {
        const __mouseDown = e => {
            if (tipsPanel.current && tipsPanel.current.contains(e.target)) {
                return;
            }
            setIsShowTips(false);
        };

        if (isShowTips) {
            window.addEventListener('mousedown', __mouseDown);
        } else {
            window.removeEventListener('mousedown', __mouseDown);
        }
    }, [isShowTips]);

    return (
        <FJAppLeft>
            <div className={classNames(styles.header)}>
                <div className={classNames(styles.title)}>{FJLocalStore._('upload-image')}</div>
                <div className={styles.tips} onClick={_onClickTips}>
                    {FJLocalStore._('tips')}
                    <ExclamationIcon />
                </div>
            </div>

            <div className={styles.upload_box}>
                <FJImageUpload
                    openMediaLibrary={() => openMediaLibrary('people')}
                    imageInfo={peopleImageInfo}
                    uploadImg={file => {
                        onUploadImage(file);
                    }}
                    defaultIcon={<PeopleIcon />}
                    smallIcon={<PeopleSmallIcon />}
                    uploadText={'upload-photo'}
                />
                <FJImageUpload
                    openMediaLibrary={() => openMediaLibrary('clothes')}
                    imageInfo={clothesImageInfo}
                    uploadImg={file => {
                        onUploadImage(file, true);
                    }}
                    defaultIcon={<ClothesIcon />}
                    smallIcon={<ClothesSmallIcon />}
                    uploadText={'upload-clothes'}
                />
            </div>

            <div className={classNames(styles.title)} style={{ marginBottom: 10 }}>
                {FJLocalStore._('choose-clothes')}
            </div>
            <FJClothesChangerStyleList
                list={CLOTHES_CHANGER_STYLE_LIST}
                onChange={onSelectClothes}
                selectedName={selectedName}
            />
            <div className={styles.line_through} />
            <FJGenerateButton
                onClick={onGenerate}
                taskStatus={taskStatus}
                freeNumCreation={freeNumCreation}
                isFree={isFree}
                useCredit={FJClothesChangerConfig.unitPrice}
                isProjectLoading={isProjectLoading}
            />
            <div ref={tipsPanel} className={classNames(styles.tips_content, { [styles.show]: isShowTips })}>
                <FJTipsContent />
            </div>
        </FJAppLeft>
    );
};
FJClothesChangerLeft.propTypes = {
    onGenerate: PropTypes.func,
    taskStatus: PropTypes.string,
    freeNumCreation: PropTypes.number,
    creditNumber: PropTypes.number,
    peopleImageInfo: PropTypes.object,
    clothesImageInfo: PropTypes.object,
    onUploadImage: PropTypes.func,
    selectedStyle: PropTypes.string,
    onSelectClothes: PropTypes.func,
    isProjectLoading: PropTypes.bool,
    openMediaLibrary: PropTypes.func,
    selectedName: PropTypes.string,
};
export default FJClothesChangerLeft;
